import { fetchWithChatFeedback } from './chatFeedbackRequired';
import type { TrainingEntrySource } from '../training/trainingEntry';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export async function recordTrainingEntry(eventId: string, source: TrainingEntrySource): Promise<void> {
  const response = await fetchWithChatFeedback(`${API_BASE_URL}/api/training/entry`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ event_id: eventId, source }),
  });
  if (!response.ok) throw new Error(`Training entry report failed (${response.status})`);
  const body = await response.json();
  if (body.success !== true) throw new Error('Training entry report failed');
}

export type TrainingEntrySourceCounts = Record<TrainingEntrySource | 'direct_or_unknown', number>;
export interface TrainingEntrySourcesReportData {
  start_date: string;
  end_date: string;
  total: number;
  counts: TrainingEntrySourceCounts;
}

export async function fetchTrainingEntrySources(start: string, end: string): Promise<TrainingEntrySourcesReportData> {
  const params = new URLSearchParams({ start, end });
  const response = await fetchWithChatFeedback(`${API_BASE_URL}/api/admin/training-entry-sources?${params}`, {
    credentials: 'include',
  });
  if (!response.ok) throw new Error(`Training source report failed (${response.status})`);
  return response.json();
}
